<div class="dialog-wrapper">
  <app-modal-header-common
    [title]="data?.template_name"
    [dialogRef]="dialogRef"
  >
  </app-modal-header-common>
  <div class="dialog-content">
    <div class="plan-form">
      <form [formGroup]="assessmentForm">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Assessment Name</mat-label>
          <input matInput formControlName="name" required />
        </mat-form-field>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.portfolio }}</mat-label>
              <input
                matInput
                [matAutocomplete]="auto"
                type="text"
                formControlName="portfolio"
                required
              />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let option of filterOptionPortfolio | async"
                  [value]="option"
                  (onSelectionChange)="onSelectionChangePortfolio($event)"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.sub_portfolio }}</mat-label>
              <input
                matInput
                [matAutocomplete]="auto1"
                type="text"
                formControlName="subportfolio"
                required
              />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete
                #auto1="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let option of filterOptionSubPortfolio | async"
                  [value]="option"
                  (onSelectionChange)="onSelectionChangeSubportfolio($event)"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.program }}</mat-label>
              <input
                matInput
                [matAutocomplete]="auto2"
                type="text"
                formControlName="program"
                required
              />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete
                #auto2="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let option of filterOptionProgram | async"
                  [value]="option"
                  (onSelectionChange)="onSelectionChangeProgram($event)"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label> {{ displayLabels?.project | titlecase }} </mat-label>
              <input
                matInput
                [matAutocomplete]="auto3"
                type="text"
                formControlName="project"
                required
              />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete
                #auto3="matAutocomplete"
                [displayWith]="displayFnProject"
              >
                <mat-option
                  *ngFor="let option of filterOptionProject | async"
                  [value]="option"
                >
                  {{ option.project_name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>OU/GDP</mat-label>
              <input
                matInput
                [matAutocomplete]="auto4"
                type="text"
                formControlName="vendor"
                required
              />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete
                #auto4="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let option of filterOptionVendor | async"
                  [value]="option"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <app-owner
                [label]="'Audience'"
                [required]="true"
                [programId]="assessmentForm.get('program')?.value"
                filterOwner="{{ true }}"
                [context]="'assessment'"
                (refereshParentData)="audiencedata($event)"
              ></app-owner>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <app-owner
                [label]="'Respondent'"
                [required]="true"
                [programId]="assessmentForm.get('program')?.value"
                filterOwner="{{ true }}"
                [context]="'assessment'"
                (refereshParentData)="userdata($event)"
              ></app-owner>
            </div>
          </div>
        </div>

        <p class="mb-2">
          Assessment period<span class="required-asterisk"> *</span>
        </p>
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker1"
                formControlName="start_date"
                required
              />
              <mat-datepicker-toggle matSuffix [for]="picker1">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>End Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker2"
                formControlName="end_date"
                required
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Applications (multi-select) -->
        <ng-container *ngIf="isProjectSelected">
          <mat-form-field
            style="width: 100%"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>Applications</mat-label>
            <mat-chip-list #appChipList aria-label="Applications selection">
              <mat-chip
                *ngFor="let app of selectedApps; let i = index"
                class="selected-app"
                [selectable]="true"
                [removable]="true"
                (removed)="removeApp(i)"
              >
                {{ app?.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>

              <input
                type="text"
                placeholder="Search applications..."
                [formControl]="appUserInputControl"
                [matChipInputFor]="appChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                [matAutocomplete]="appAuto"
                #appOperationTrigger="matAutocompleteTrigger"
                name="application_name"
                (click)="appOperationTrigger.openPanel()"
              />
            </mat-chip-list>

            <mat-autocomplete
              #appAuto="matAutocomplete"
              (optionSelected)="addApp($event.option.value)"
            >
              <mat-option
                *ngFor="let option of appFilteredOptions | async"
                [value]="option"
              >
                <span class="autofill-option">{{ option.name }}</span>
              </mat-option>

              <!-- No records found -->
              <mat-option
                *ngIf="(appFilteredOptions | async)?.length === 0"
                disabled
              >
                {{ commonText.no_records_found }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="modal-footer" style="display: flex; justify-content: end">
    <button
      (click)="closeModal()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      class="templ-btn"
      (click)="createAssessment()"
      [disabled]="isLoading || assessmentForm.invalid"
    >
      Create
    </button>
  </div>
</div>
